<template>
	<div class="wraper">
		<Form ref="form" @handleReset='handleReset' @handleChange="handleChange" @handleSubmit="handleSubmit"
			:form_data="form_data">
		</Form>
		<div class='btn-box'>


			<a-button style="margin-right: 10px;" class="float_left" @click="add('')" type="primary">新增</a-button>
			<a-button style="margin-right: 10px;" class="float_left" @click="getMarketRuleTypeFun"
				type="primary">配置市场类型</a-button>
			<a-button style="margin-right: 10px;" @click="getCustomerRuleTypeFun" class="float_left"
				type="primary">配置客户类别</a-button>
			<a-button style="margin-right: 10px;" class="float_left" @click="getGardFun"
				type="primary">配置等级类别</a-button>
		</div>
		<a-table :columns="columns" :dataSource="flatData" bordered :pagination="false">
			<!-- 规则状态列 -->
			<template slot="status" slot-scope="text, record">
				<a-switch size="small" :checked="record.status === 1"
					@change="val => handleStatusChange(val, record)" />
			</template>
			<!-- 操作列 -->
			<template slot="action" slot-scope="text, record">
				<a @click='updateCustomerLevelFun(record)' v-auth="'change'" href="javascript:;">更新</a>
				<a-divider type="vertical" v-auth="'change'" />
				<a href="javascript:;" @click='add(record.info_id)' v-auth="'change'">编辑</a>
				<a-divider type="vertical" v-auth="'delete'" />
				<span>
					<a-popconfirm title="您确定要删除吗?" v-auth="'delete'" @confirm="del(record)">
						<a>删除</a>
					</a-popconfirm>
				</span>
			</template>
		</a-table>
		<a-modal title="配置等级类别" @onCancel='add_grade_visible=false;grade=[]' v-model:visible="add_grade_visible"
			@ok="add_grade_ok" width="600px" class="modal">
			<p style="margin-bottom: 10px;">
				“等级规则”配置上限等于以下“等级类别”数量，请先新增等级类别
			</p>
			<div class="item">
				<a-button @click='grade.push({"id":"","name":"","unit":1})' type="primary">
					新增
				</a-button>
			</div>
			<div class="item">
				<p class="unit_p" v-for="(item,index) in grade">
					<span class="level">第{{toChineseNum(index+1)}}级别</span>
					<a-input v-model:value="item.name" placeholder="请输入等级类别名称" />
					<a-icon class="level delete_icon" type="delete" @click='del_grade_list(index)' />
				</p>
			</div>
		</a-modal>
		<a-modal title="配置市场类型" @onCancel='market_tier_visible=false;market_type=[];statistical_period=null'
			v-model:visible="market_tier_visible" @ok="add_saveMarketType_ok" width="600px" class="modal">
			<p>
				统计周期：
			</p>
			<p>
				<a-select @change="changeSelect" v-model='statistical_period' style="width: 100%">
					<a-select-option :value="it.value" :key='itindex' v-for='(it,itindex) in period_type'>
						{{it.label}}
					</a-select-option>
				</a-select>
			</p>

			<p style="margin-top: 10px;margin-bottom: 10px;color:#999;">
				{{period_type_desc}}
			</p>
			<p>
				市场类型：
			</p>
			<div class="item">
				<p class="unit_p" v-for="(item,index) in market_type">
					<a-input v-model:value="item.name" placeholder="请输入等级类别名称" />
					<a-icon class="level delete_icon" type="delete" @click='del_market_type_list(index)' />
				</p>
			</div>
			<div class="item">
				<a-button style='margin-top:12px;' @click="market_type.push({id:'',name:''})" type="primary">
					新增类别
				</a-button>
			</div>
		</a-modal>

		<a-modal title="配置客户类别" :zIndex='9' @onCancel='customer_category_visible=false;level_list=[]'
			v-model:visible="customer_category_visible" @ok="add_customer_category_ok" width="700px" class="modal">
			<p>客户类别名称</p>
			<div class="item">
				<p class="unit_p" v-for="(item,index) in level_list">
					<a-input v-model:value="item.name" placeholder="请输入等级类别名称" />
					<a-icon class="level delete_icon" type="delete" @click='del_list(index)' />
					<span class="level">已选<span class="blue">{{item.group_infos.length}}</span>个</span>
					<a-button @click="customer_category_addDapFun(index,item)">
						选择客户类型
					</a-button>
				</p>
			</div>
			<div class="item">
				<a-button style='margin-top:12px;' @click='level_list.push({
            "id":"","name":"", "group_infos":[]})' type="primary">
					新增类别
				</a-button>
			</div>
		</a-modal>
		<a-modal title="选择区域" v-model:visible="customer_category_sub_visit" @ok="dap_ok" width="800px" class="modal">
			<div class="tree-transfer-box">
				<div style="margin-bottom: 12px;">
					当前市场类型：<span style="color:#1890ff;">{{category_sub_name}}</span> <span>{{category_sub_tips}}</span>
				</div>
				<a-transfer :titles="['选择区域', '已选区域']" class="tree-transfer" :data-source="dataList"
					:target-keys="targetKeys" :render="item => item.name" @change="onChange">
					<template slot="children"
						slot-scope="{ props: { direction, selectedKeys }, on: { itemSelect,itemSelectAll } }">
						<a-tree :auto-expand-parent='true' :replaceFields="{children:'sub', title:'name', key:'id' }"
							v-if="direction === 'left'" blockNode checkable
							:checkedKeys="[...selectedKeys, ...targetKeys]" :treeData="treeData" @check="
			            (_, props) => {
			              onChecked(_, props, [...selectedKeys, ...targetKeys], itemSelect);
			            }
			          " @select="
			            (_, props) => {
			              onChecked(_, props, [...selectedKeys, ...targetKeys], itemSelect);
			            }
			          " />
					</template>
				</a-transfer>
			</div>
		</a-modal>

		<a-modal :zIndex='999' :title="type_id?'查看客户类型':'添加/修改客户类型'" v-model:visible="customer_category_sub_visit_type"
			@ok="dap_ok2" width="800px" class="modal">
			<div class="tree-transfer-box">
				<div style="margin-bottom: 12px;">
					当前客户类型：<span>{{market_name}}</span> <span>{{market_tips}}</span>
				</div>
				<a-transfer :disabled="type_id?true:false"
					:filter-option="(inputValue, item) => item.title.indexOf(inputValue) !== -1"
					:show-select-all="false" :titles="['客户类型', '已选客户类型']" class="tree-transfer" :data-source="typeList"
					:target-keys="typeKeys" :render="item => item.name" :rowKey="item => item.id" @change="onChange2">
					<template slot="children"
						slot-scope="{ props: { direction, selectedKeys }, on: { itemSelect,itemSelectAll } }">
						<a-tree :disabled="type_id?true:false" :replaceFields="{children:'childlist' }"
							v-if="direction === 'left'" blockNode checkable
							:checkedKeys="[...selectedKeys, ...typeKeys]" :treeData="typeData" @check="
			            (_, props) => {
			              onChecked2(_, props, [...selectedKeys, ...typeKeys], itemSelect);
			            }
			          " @select="
			            (_, props) => {
			              onChecked2(_, props, [...selectedKeys, ...typeKeys], itemSelect);
			            }
			          " />
					</template>
				</a-transfer>
			</div>
		</a-modal>


	</div>
</template>


<script>
	import TableList from "@/components/TableList";
	import Form from "@/components/Form";
	import {
		getStatisticalPeriodType,
		saveMarketType,
		saveCustomerRuleGrade,
		getMarketType,
		getLevelRuleList,
		getMarketAndType,
		changeLevelRuleStatus,
		deleteLevelRule,
		updateCustomerLevel,
		saveCustomerRuleType,
		saveMarketDepartment,
		getMarketDepartment,
		getCustomerRuleType,
		getCustomerRuleGrade
	} from "@/api/market_type";
	import {
		message,
		Modal
	} from 'ant-design-vue'

	export default {
		name: "competingrate",
		components: {
			TableList,
			Form
		},
		data() {
			return {
				period_type_desc: '',
				grade: [],
				statistical_period: '',
				market_type: [],
				dataList: [],
				treeData: [],
				targetKeys: [],
				typeList: [],
				typeData: [],
				typeKeys: [],
				targetKeysTemp: [],
				customer_category_sub_visit: false,
				customer_category_visible: false,
				customer_category_sub_visit_type: false,
				add_grade_visible: false,
				market_tier_visible: false,
				level_list: [],
				type_id: '',
				submit_preprocessing: {
					array_to_string: ['department', 'role']
				},
				details: {
					visit_data: {

					},
				},
				searchInfo: {},
				slot_table_list: ['total'],
				goods_list: [],
				tableData: [],
				drawer_visible: false,
				period_type: [],
				dataTypeList: [],

				form_data_seo: {
					...this.$config.form_data_seo,
					list: [{
							type: "select",
							name: "market_id",
							title: "市场类型",
							placeholder: '请选择',
							list: []
						},


					],

				},
				form_data: {},
				info_grade: [],
				department_info: [],
				area_id: '',
				apiData: [],
				tempDaps: 0,
				category_sub_name: '',
				category_sub_tips: '',
				market_name: '',
				market_tips: '',
				already_depart: [],
				form_data: {
					title: '搜索',
					show_submit_btn: true,
					show_close_btn: false,
					submit_name: "查询",
					layout: 'inline',
					list: [{
							type: "select",
							name: "market_id",
							title: "市场类型",
							placeholder: '请选择',
							list: []

						},
						{
							type: "text",
							name: "keyword",
							placeholder: "请输入标签",
						},

					]
				}
			};
		},

		async created() {
			this.getStatisticalPeriodTypeFun()
			Promise.all([this.$method.get_department(), this.$method.get_group()]).then(
				res => {
					this.treeData = this.handleTreeData(res[0], this.targetKeys)

					this.flatten(JSON.parse(JSON.stringify(this.treeData)));


					this.typeData = this.handleTreeData2(res[1], this.typeKeys)

					this.flatten2(JSON.parse(JSON.stringify(this.typeData)));
				});
			getMarketAndType().then(info => {
				this.form_data.list[0].list = info.data.market_type.map(it => {
					return {
						key: it.value,
						value: it.label
					}
				})
				this.info_grade = info.data.grade

			})
			this.getList()


		},
		mounted() {

		},
		computed: {
			// 1. 动态生成列 (包含 ABCD 动态列)
			columns() {
				// 基础列
				const baseColumns = [{
							title: 'ID',
							dataIndex: 'market_id',
							customRender: (text, record) => ({
								children: text,
								attrs: {
									rowSpan: record.rowSpan
								}
							})
						},
						{
							title: '市场类型',
							dataIndex: 'market_name',
							customRender: (text, record) => ({
								children: < div > < p style = "color: #1890ff" > {

										record.sub_name
									} <
									/p> <p  > {text}  </p > < /div>,
								attrs: {
									rowSpan: record.rowSpan
								}
							})
						},
						{
							title: '区域数',
							dataIndex: 'num',
							customRender: (text, record) => ({
									children: ( < div > < div > {
											text
										}
										个 <
										/div> <span onClick={() => this.addDap(record)} style = "color: #1890ff;font-size:12px;" > 请选择  </span >
										<
										/div>),
										attrs: {
											rowSpan: record.rowSpan
										}
									})
							},
							{
								title: '客户类别',
								dataIndex: 'customer_type',
								customRender: (text, record) => < span onClick = {
									() => this.get_customer_type(record)
								}
								style = "color: #1890ff" > {
									text
								} < /span>
							}
						];

						// 动态生成 ABCD 列
						const abcdColumns = this.info_grade.map(item => ({
							title: `${item.label}（件）`,
							key: `grade_${item.value}`,
							// 通过 customRender 提取 rule_info 并格式化
							customRender: (text, record) => {
								const rule = record.rule_info[item.value];
								return this.formatRule(rule);
							}
						}));

						// 操作列
						const actionColumns = [{
								title: '规则状态',
								key: 'status',
								scopedSlots: {
									customRender: 'status'
								}
							},
							{
								title: '操作',
								key: 'action',
								scopedSlots: {
									customRender: 'action'
								}
							}
						];
						return [...baseColumns, ...abcdColumns, ...actionColumns];
					},
					// 2. 扁平化数据并计算合并单元格 rowSpan
					flatData() {
						let result = [];
						this.apiData.forEach(market => {
							if (!market.sub_data) return;
							const len = market.sub_data.length;

							market.sub_data.forEach((sub, index) => {
								result.push({
									key: `${market.market_id}-${sub.id}-${index}`,
									market_id: market.market_id,
									info_id: sub.id,
									market_name: market.market_name,
									num: market.num,
									customer_type: `${sub.type_name} `,
									rule_info: sub.rule_info,
									status: sub.status,
									type_id: sub.type_id,
									sub_name: market.name,
									ids: market.ids,
									// 核心逻辑：只有第一行拥有合并的 span，其他行设为 0 来隐藏
									rowSpan: index === 0 && len >= 1 ? len : 0
								});
							});
						});

						return result;
					}
			},

			methods: {
				getMarketRuleTypeFun() {
					getMarketType().then(info => {
						this.market_type = info.data.market_type
						this.statistical_period = info.data.statistical_period
						this.period_type.forEach(it => {
							if (it.value == info.data.statistical_period) {
								this.period_type_desc = it.desc
							}
						})
					})
					this.market_tier_visible = true;
				},
				getGardFun() {
					getCustomerRuleGrade().then(info => {
						this.grade = info.data.grade
					})
					this.add_grade_visible = true;
				},
				getCustomerRuleTypeFun() {
					getCustomerRuleType().then(res => {
						this.level_list = res.data.rule_type
						this.customer_category_visible = true
					})
				},


				add_customer_category_ok() {
					saveCustomerRuleType({
						data: {
							rule_type: this.level_list
						}
					}).then(res => {
						this.customer_category_sub_visit_type = false
						this.customer_category_visible = false
						this.tempDaps = -1
						this.level_list = []
						message.success('添加成功')
						this.getList()
					})
				},
				handleChange() {},
				handleReset() {
					this.searchInfo = {}
					this.getList()
				},
				handleSubmit(e) {

					this.searchInfo = e.values
					this.getList()
				},

				customer_category_addDapFun(index, arr) {

					this.targetKeysTemp = []
					this.level_list.forEach((it, itindex) => {
						if (itindex != index) {
							it.group_infos.map(i => {
								this.targetKeysTemp.push(String(i.group_id))
							})
						}

					})

					this.typeKeys = []
					this.typeKeys = arr.group_infos.map(res => {
						return String(res.group_id)
					})
					this.type_id = ''
					this.market_tips = arr.name
					this.tempDaps = index
					this.typeData = this.handleTreeData2(this.typeData, this.typeKeys)
					this.customer_category_sub_visit_type = true
				},
				updateCustomerLevelFun(record) {
					updateCustomerLevel({
						data: {
							id: record.info_id
						},
					}).then(res => {
						message.success('更新成功')
						this.getList()
					})
				},
				del(record) {
					deleteLevelRule({
						data: {
							id: record.info_id
						},
						info: true,
					}).then(res => {
						this.getList()
					})
				},

				flatten(list = []) {
					list.forEach(item => {
						item.id = String(item.id)
						item.key = String(item.key)
						this.dataList.push(item);
						this.flatten(item.sub);
					});

				},
				flatten2(list = []) {
					list.forEach(item => {
						item.key = item.id
						item.title = item.name
						this.typeList.push(item);
						if (item.childlist.length > 0) {
							this.flatten2(item.childlist);
						}

					});
				},
				// 拼接规则的方法
				formatRule(rule) {
					if (!rule) return '-';
					const f1 = (rule.field1 || '').trim(); // "≥"
					const f2 = (rule.field2 || '').trim(); // "033" 或 "400"
					const f3 = (rule.field3 || '').trim(); // "" 或 "<"
					const f4 = (rule.field4 || '').toString().trim(); // "0" 或 "1000"
					// 如果两边都有值 (例如 400 ≤ 年销量 < 1000)
					if (f3) {
						return `${f2} ${f1} 年销量 ${f3} ${f4}`;
					}
					// 如果只有单边值 (例如 年销量 ≥ 033)
					return `年销量 ${f1} ${f2}`;
				},
				handleStatusChange(val, record) {
					changeLevelRuleStatus({
						data: {
							id: record.info_id,
							status: record.status == 1 ? 0 : 1
						}
					}).then(res => {
						message.success('保存成功')
						this.getList()
					})
				},
				getList() {
					getLevelRuleList({
						data: {
							...this.searchInfo
						}
					}).then(res => {
						this.apiData = res.data.list
					})
				},
				changeSelect(e, info) {
					this.period_type.forEach(it => {
						if (it.value == e) {
							this.period_type_desc = it.desc
						}
					})
				},
				del_grade_list(index) {
					let that = this
					Modal.confirm({
						title: () => '等级类别删除提示',
						content: () => '是否确认删除当前等级类别，删除后，该类别关联配置项将会清除，请谨慎操作？',
						okText: '确认',
						cancelText: '取消',
						onOk() {
							that.grade.splice(index, 1)
						},
						onCancel() {},
					});

				},

				toChineseNum(num) {
					const map = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
					if (num >= 1 && num <= 10) return map[num];
					// 如需支持更大数字，可自行扩展
					return num; // fallback
				},
				// 计算倒序后的索引对应的原始索引
				getOriginalIndex(index) {
					return this.grade.length - 1 - index;
				},
				del_market_type_list(index) {
					let that = this
					Modal.confirm({
						title: () => '等级市场类型删除提示',
						content: () => '是否确认删除当前市场类型，删除后，该类别关联配置项将会清除，请谨慎操作？',
						okText: '确认',
						cancelText: '取消',
						onOk() {
							that.market_type.splice(index, 1)
						},
						onCancel() {},
					});

				},
				add_saveMarketType_ok() {
					saveMarketType({
						data: {
							statistical_period: this.statistical_period,
							market_type: this.market_type
						}
					}).then(res => {
						message.success('保存成功')
						this.market_tier_visible = false
						this.getList()
					})
				},
				add_grade_ok() {
					saveCustomerRuleGrade({
						data: {
							grade: this.grade
						}
					}).then(res => {
						message.success('保存成功')
						this.add_grade_visible = false
						getMarketAndType().then(info => {
							this.info_grade = info.data.grade

						})
						this.getList()


					})
				},
				getStatisticalPeriodTypeFun() {
					getStatisticalPeriodType().then(res => {
						this.period_type = res.data.list
					})

				},
				add(id) {
					this.$router.push("/market_type/edit?info_id=" + id);
				},
				isChecked(selectedKeys, eventKey) {
					return selectedKeys.indexOf(eventKey) !== -1;
				},
				dap_ok() {
					saveMarketDepartment({
						data: {
							ids: this.area_id.join(','),
							department_info: this.department_info
						}
					}).then(res => {
						this.customer_category_sub_visit = false
						this.area_id = ''
						this.department_info = []
						this.targetKeys = []
						this.market_name = ''
						this.market_tips = ''
						this.getList()
					})
				},


				handleTreeData(data, targetKeys = [], disabled) {
					data.forEach(item => {

						if (disabled) {
							item['disabled'] = true
						} else {
							item['disabled'] = targetKeys.includes(item.key);
							item['disabled'] = this.already_depart.includes(item.key);
						}
						
						item.id = String(item.id)
						item.key = String(item.key)
						if (item.sub && item.sub.length > 0) {
							if (item.disabled) {
								this.handleTreeData(item.sub,targetKeys, item.disabled);
							} else {
								this.handleTreeData(item.sub, targetKeys,item.disabled);
							}

						}
					});
					return data;
				},
				chooseTreeData(data) {
					data.forEach(item => {
						if (this.targetKeys.indexOf(item.id) > -1) {
							this.department_info.push({
								"department_id": item.id,
								"department_name": item.name
							})
						}
						if (item.sub && item.sub.length > 0) {
							this.chooseTreeData(item.sub);
						}
					});
					return data;
				},
				onChange(targetKeys) {
					this.targetKeys = targetKeys.map(it => {
						return String(it)
					});
					this.chooseTreeData(this.treeData)
				},
				get_customer_type(info) {
					getCustomerRuleType({
						data: {
							type_id: info.type_id
						}
					}).then(res => {
						this.type_id = info.type_id
						this.market_name = info.market_name
						this.market_tips = info.sub_name + '/' + info.customer_type
						this.typeKeys = res.data.rule_type[0].group_infos.map(it => {
							return String(it.group_id)
						})
						this.customer_category_sub_visit_type = true
					})
				},
				addDap(info) {
					this.area_id = info.ids
					this.category_sub_name = info.market_name
					this.category_sub_tips = info.sub_name
					this.already_depart=[]
					this.targetKeys-[]
					getMarketDepartment({
						data: {
							ids: info.ids
						}
					}).then(res => {
						this.already_depart = res.data.already_depart.map(it=>{
							return String(it)
						})
						if (res.data.list) {
							this.targetKeys = res.data.list.map(it => {
								return String(it.department_id)
							})
						}
						this.treeData = this.handleTreeData(this.treeData, this.targetKeys)
						this.customer_category_sub_visit = true
					})
				},

				dap_ok2() {
					this.customer_category_sub_visit_type = false
					this.level_list[this.tempDaps].group_infos = []
					this.chooseTreeData2(this.typeData)
				},
				chooseTreeData2(data) {

					data.forEach(item => {
						if (this.typeKeys.indexOf(item.id) > -1) {
							this.level_list[this.tempDaps].group_infos.push({
								"group_id": item.id,
								"group_name": item.name
							})
						}

						if (item.childlist.length > 0) {
							this.chooseTreeData2(item.childlist);
						}
					});
					return data;
				},

				handleTreeData2(data, typeKeys = [], disabled) {

					data.forEach(item => {
						if (disabled) {
							item['disabled'] = true
						} else {
							item['disabled'] = typeKeys.includes(item.key);
							item['disabled'] = this.targetKeysTemp.includes(item.key);
						}

						item.title = String(item.name)
						item.key = String(item.id)
						item.id = String(item.id)

						if (item.childlist) {
							if (item.disabled) {
								this.handleTreeData2(item.childlist, typeKeys, true);
							} else {
								this.handleTreeData2(item.childlist, typeKeys, false);
							}
						}
					});
					return data;
				},
				onChange2(typeKeys) {
					this.typeKeys = typeKeys.map(it => {
						return String(it)
					});
				},
				onChecked2(_, e, checkedKeys, itemSelect) {
					const {
						eventKey
					} = e.node;
					itemSelect(eventKey, !this.isChecked(checkedKeys, eventKey));
				},



				onChecked(_, e, checkedKeys, itemSelect) {
					const {
						eventKey
					} = e.node;
					itemSelect(eventKey, !this.isChecked(checkedKeys, eventKey));
				},
				del_list(index) {
					let that = this
					Modal.confirm({
						title: () => '客户类别删除提示',
						content: () => '是否确认删除当前客户类别，删除后，该类别关联配置项将会清除，请谨慎操作？',
						okText: '确认',
						cancelText: '取消',
						onOk() {
							that.level_list.splice(index, 1)
						},
						onCancel() {},
					});
				},
				add_ok() {

				},


				list_after(res) {
					let list = this.$refs.list.list;
					list = list.map((item, index) => {
						item.children = [];

						return item;
					});

				},

			}
		};
</script>

<style lang="less">
	@import url("../../../assets/less/app.less");

	.visit_img {
		width: 60px;
		height: 60px;
	}

	.unit_p {
		display: flex;
		align-items: center;
		margin-top: 12px;

		.level {
			width: 150px;
		}



	}

	.delete_icon {
		color: red;
	}

	.tree-transfer-box {
		height: 600px;
		overflow: auto;

	}

	.tree-transfer .ant-transfer-list:first-child {
		width: 50%;
		flex: none;
	}

	.ant-transfer-disabled .ant-transfer-list {
		background: none;
	}

	.wraper {
		margin: 12px;
		padding: 12px;
		background: #fff;
	}

	.btn-box {
		margin: 12px 0px;
	}

	.blue {
		color: #1890ff;
		margin: 0 12px;
	}
</style>